import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorGetAttachmentService } from '../../api/ai-creator'
import { GET_RECENT_ATTACHMENTS } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getRecentAttachmentsFlow(payload) {
  try {
    const {callback } = payload

    const response = yield call(AICreatorGetAttachmentService)
    callback(response)

    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* aICreatorGetRecentAttachmentsWatcher() {
  while (true) {
    const action = yield take(GET_RECENT_ATTACHMENTS)
    const { payload } = action

    yield fork(generalSaga, getRecentAttachmentsFlow, payload)
  }
}
